import commonPostTypeConfig from '../../common/postTypes/apply'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'apply',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
